import { Button, Stack, Typography } from '@customink/pigment-react';
import React from 'react';
import { CushionedBox } from '~/components/Layout/CushionedBox';
import { TaxExemptionsCreatePortalButton } from '~/pages/Settings/tabs/TaxExemption/components/Portal/Verify/TaxExemptionsCreatePortalButton';
import { LinkInBlank } from '~/components/Link/LinkInBlank';

interface TaxExemptionsPortalButtonProps {
    portalUrl: string | null;
}

const verifyTaxExemptButtonText = 'Verify Tax Exempt Status';

export const TaxExemptionsVerifyStatusButton: React.FC<TaxExemptionsPortalButtonProps> = ({
    portalUrl,
}: TaxExemptionsPortalButtonProps) => {
    return (
        <CushionedBox>
            <Typography variant="bodyShort2" paragraph>
                Once we&apos;ve verified your tax exempt status, you can apply it <br />
                to qualifying purchases during checkout.
            </Typography>
            <Stack alignItems="center">
                <Stack spacing={2}>
                    {/* We want to provide a seamless experience to the user. The user won't care whether they already have */}
                    {/* a portal or not. (As long as there are no tax exemptions to show,) we want to show them these same-looking buttons. */}
                    {portalUrl ? (
                        <Button href={portalUrl} LinkComponent={LinkInBlank}>
                            {verifyTaxExemptButtonText}
                        </Button>
                    ) : (
                        <TaxExemptionsCreatePortalButton>{verifyTaxExemptButtonText}</TaxExemptionsCreatePortalButton>
                    )}
                </Stack>
            </Stack>
        </CushionedBox>
    );
};
